import { useEffect, useState } from "react";

let designerSelectedFormItem: DesignerSelectedFormItem | undefined = undefined;
let changeListeners: ((newFormItem: DesignerSelectedFormItem | undefined, oldFormItem: DesignerSelectedFormItem | undefined) => void)[] = [];

export interface DesignerSelectedFormItem {
    stepIdentifier: string;
    index: number;
}

export default function useDesignerSelectedFormItem() {
    let [index, setIndex] = useState<DesignerSelectedFormItem | undefined>(designerSelectedFormItem);
    useEffect(() => {
        let listener = (newIndex: DesignerSelectedFormItem | undefined, oldFormItem: DesignerSelectedFormItem | undefined) => setIndex(newIndex);
        changeListeners.push(listener);
        return () => {
            changeListeners = changeListeners.filter(l => l !== listener);
        }
    });
    return index;
}

export function designFormItem(newSelectedFormItem: DesignerSelectedFormItem | undefined) {
    let oldFormItem = designerSelectedFormItem;
    if (designerSelectedFormItem?.index === newSelectedFormItem?.index && designerSelectedFormItem?.stepIdentifier === newSelectedFormItem?.stepIdentifier) {
        designerSelectedFormItem = undefined;
    } else {
        designerSelectedFormItem = newSelectedFormItem;
    }
    changeListeners.forEach(l => l(designerSelectedFormItem, oldFormItem));
}

export function onDesignerSelectedFormItemChange(listener: (newFormItem: DesignerSelectedFormItem | undefined, oldFormItem: DesignerSelectedFormItem | undefined) => void) {
    changeListeners.push(listener);
}